import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export function todayValueOf() {
  return moment().startOf('day').valueOf();
}

export function getDurationInHours(start, end) {
  if (!end) {
    return 0;
  }

  // Optimize: avoid creating moment objects for simple math (1 hr = 3600000 ms)
  const diffMs = Number(end) - Number(start);
  const duration = diffMs / 3600000;

  return Math.abs(duration);
}

export function formatDuration(duration) {
  return moment.duration(duration, 'hours').format('h[h] mm[m]');
}

export function sumEntriesByWork(entries) {
  return entries.reduce((acc, entry) => {
    const workId = entry.work.id;
    const duration = getDurationInHours(entry.start, entry.end);

    if (acc[workId]) {
      acc[workId] += duration;
    } else {
      acc[workId] = duration;
    }

    return acc;
  }, {});
}

export function sortEntries(entries) {
  return entries.sort((a, b) => a.start - b.start);
}

export function getExtemumEntries(sortedEntries) {
  const earliestEntry = sortedEntries[0];
  const latestEntry = sortedEntries[sortedEntries.length - 1];

  return { 
    earliestEntry,
    latestEntry,
  };
}

export function getMinX(earliestEntry, projectStart) {
  if (earliestEntry && earliestEntry.start) {
    return moment(Number(earliestEntry.start)).subtract(1, 'day').startOf('day').valueOf();
  }
  if (projectStart) {
    return moment(Number(projectStart)).subtract(1, 'day').startOf('day').valueOf();
  }
  return moment().subtract(1, 'day').startOf('day').valueOf();
}

export function getMaxX(projectEnd, latestEntry) {
  const endMoment = projectEnd ? moment(Number(projectEnd)) : moment().add(1, 'month');

  if (latestEntry && latestEntry.start) {
    return endMoment.isAfter(Number(latestEntry.start))
      ? endMoment.add(1, 'day').startOf('day').valueOf()
      : moment(Number(latestEntry.start)).add(1, 'day').startOf('day').valueOf();
  }

  return endMoment.add(1, 'day').startOf('day').valueOf();
}

export function getMaxY(predictedValue, budget) {
  const pVal = predictedValue || 0;
  const bVal = budget || 0;
  return Math.round((pVal > bVal ? pVal : bVal) * 1.1) || 10;
}

export function getTotalSpentTime(progressSeriesData) {
  if (!progressSeriesData || progressSeriesData.length === 0) return 0;
  return progressSeriesData[progressSeriesData.length - 1][1];
}

export function getTotalSpentTimeFirstDay(progressSeriesData) {
  if (!progressSeriesData || progressSeriesData.length === 0) return 0;
  return progressSeriesData[0][1];
}
